import React, { Component } from 'react';
import PropTypes from 'prop-types';

const { ADV } = window;

export default class WhatIfsSectionView extends Component {
  static renderWhatIfsList(whatIfs, onClick) {
    const eventHandler = onClick || (() => () => {});
    return whatIfs.map(whatIf =>
      !whatIf.isApplied ? (
        <li key={whatIf.id}>
          <button type="button" onClick={eventHandler(whatIf)}>
            {whatIf.question}
          </button>
        </li>
      ) : (
        <li key={whatIf.id} className="what-ifs-subsection">
          <button type="button" className="is-applied" onClick={eventHandler(whatIf)}>
            {whatIf.question}
          </button>
          <i
            role="button"
            aria-label="Remove applied what if"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={whatIf.onRemove}
            onKeyPress={whatIf.onRemove}
            className="fa fa-times-circle what-ifs-remove"
          />
        </li>
      ),
    );
  }

  constructor() {
    super();
    this.onMeasureElementReady = this.onMeasureElementReady.bind(this);
    this.getListStyle = this.getListStyle.bind(this);
    this.state = {
      height: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState === this.state) {
      if (this.measureElement) {
        this.onMeasureElementReady(this.measureElement);
      }
    }
  }

  onMeasureElementReady(measureElement) {
    this.measureElement = measureElement;
    let stateSet = false;
    if (measureElement) {
      const height = parseFloat(ADV.util.getCss(measureElement, 'height'));
      if (ADV.util.isNumeric(height)) {
        this.setState({
          height,
        });
        stateSet = true;
      }
    }

    if (!stateSet) {
      this.setState({
        height: null,
      });
    }
  }

  getListStyle(focused) {
    if (focused) {
      if (ADV.util.isNumeric(this.state.height)) {
        return {
          height: `${this.state.height}px`,
        };
      }
    }
    return {};
  }

  render() {
    const {
      setCurrentViewId,
      goalId,
      clientId,
      sectionId,
      sectionTitle,
      focused,
      setSelectedSection,
      whatIfs,
      goalType,
    } = this.props;
    return (
      <li className="what-ifs-section">
        <button
          type="button"
          onClick={setSelectedSection(clientId, goalId, focused ? null : sectionId)}
          aria-expanded={focused}
        >
          {sectionTitle}
          <i className={`caret fa fa-caret-down${focused ? ' reversed' : ''}`} />
        </button>
        {focused && (
          <>
            <ul className="what-ifs-submenu" style={this.getListStyle(focused)}>
              {WhatIfsSectionView.renderWhatIfsList(
                whatIfs,
                setCurrentViewId(clientId, goalId, goalType),
              )}
            </ul>
            <ul className="what-ifs-submenu measure-height" ref={this.onMeasureElementReady}>
              {WhatIfsSectionView.renderWhatIfsList(whatIfs)}
            </ul>
          </>
        )}
      </li>
    );
  }
}

WhatIfsSectionView.propTypes = {
  clientId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  focused: PropTypes.bool.isRequired,
  setSelectedSection: PropTypes.func.isRequired,
  setCurrentViewId: PropTypes.func.isRequired,
  whatIfs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  goalType: PropTypes.string.isRequired,
};
